import React from "react";
import { FunctionComponent } from "react";
import { Blue } from "@traceair/tds";

import NavItem from "./NavItem";
import NavLabel from "./NavLabel";
import Link from "./Link";
import config from "../../../config";


interface IOfficeAppButtonProps {
  customerId: string;
  siteId: string | null;
}
const OfficeAppButton: FunctionComponent<IOfficeAppButtonProps> = ({
  customerId,
  siteId,
}: IOfficeAppButtonProps) => (
  <Link href={generateUrl(customerId, siteId)}>
    <NavItem
      icon={<OfficeAppIcon />}
      content={<NavLabel label={"View in Office"} />}
    />
  </Link>
);

const OfficeAppIcon = () => (
  <svg
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m24 12-24-12 5.94029595 12-5.94029595 12z"
      fill={Blue}
      fillRule="evenodd"
    />
  </svg>
);

export default OfficeAppButton;

const generateUrl = (customerId: string, siteId: string | null): string =>
  siteId
    ? `${config.endpoints.osnova}/#?company=${customerId}&site=${siteId}`
    : `${config.endpoints.osnova}/#?company=${customerId}`;
